import React from "react";
import Mclothes from "./Mclothes";
function Men() {
  return (
    <div className="men-c">
      <div className="big-p">
        <img
          src="https://static.wixstatic.com/media/fef19b_f6e311acea8c43868064cb720157628e~mv2.png/v1/crop/x_2,y_0,w_1998,h_2613/fill/w_560,h_732,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/fef19b_f6e311acea8c43868064cb720157628e~mv2.png"
          alt=""
        />
        <div className="men-t">
          <p>
            Men’s wedding attire has evolved to reflect both tradition and
            modern elegance. Sherwanis, bandhgalas, and Indo-western outfits are
            among the most popular choices for Indian weddings. A sherwani,
            often crafted with luxurious fabrics like silk or brocade, is
            adorned with intricate embroidery, exuding regal charm. These are
            paired with churidars or dhotis and often complemented by
            embroidered dupattas and turbans. For a more contemporary look, many
            grooms opt for bandhgalas or Indo-western suits, blending ethnic
            styles with modern tailoring. These outfits feature rich textures,
            minimal embroidery, and sleek silhouettes, offering both comfort and
            sophistication. Accessories like mojris (traditional footwear),
            brooches, and pocket squares enhance the overall look.
          </p>
        </div>
      </div>
      <h2>Find Your Perfect Look</h2>
      <Mclothes/>
    </div>
  );
}
export default Men;
